import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/main'
  },
  {
    name: 'main',
    component: () => import('@/view/main'),
    meta: { title: '查询系统' }
  },
  {
    name: 'credentials1', // 鱼计划 —— 证书查询
    component: () => import('@/view/credentials1'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials2', // 专业助教PA —— 证书查询
    component: () => import('@/view/credentials2'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials3', // 启明星工程 —— 证书查询
    component: () => import('@/view/credentials3'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials4', // 精准教学 —— 证书查询
    component: () => import('@/view/credentials4'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials5', // AAC辅助沟通技术 —— 证书查询
    component: () => import('@/view/credentials5'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials6', // 实操计划 —— 证书查询
    component: () => import('@/view/credentials6'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials7', // SLP口语开发特训营 —— 证书查询
    component: () => import('@/view/credentials7'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials8', // 社会心智课 —— 证书查询
    component: () => import('@/view/credentials8'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials9', // 家庭自然语言干预 —— 证书查询
    component: () => import('@/view/credentials9'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials10', // 思维课程 —— 证书查询
    component: () => import('@/view/credentials10'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials11', // 社会功能开发课 —— 证书查询
    component: () => import('@/view/credentials11'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials12', // 居家感统入门课程 —— 证书查询
    component: () => import('@/view/credentials12'),
    meta: { title: '证书查询系统' }
  },
  {
    name: 'credentials13', // 特殊教育助理 —— 证书查询
    component: () => import('@/view/credentials13'),
    meta: { title: '特殊教育助理' }
  },
  {
    name: 'credentials14', // tba —— 证书查询
    component: () => import('@/view/credentials14'),
    meta: { title: 'TBA查询系统' }
  },
  {
    name: 'credentials15', // ABLLS —— 证书查询
    component: () => import('@/view/credentials15'),
    meta: { title: '结业查询' }
  },
  {
    name: 'credentials16', // ABLLS —— 证书查询
    component: () => import('@/view/credentials16'),
    meta: { title: '红宝书社交课程' }
  },
  {
    name: 'credentials17', // ABLLS —— 证书查询
    component: () => import('@/view/credentials17'),
    meta: { title: '红宝书融合课程' }
  },
  {
    name: 'credentials18', // ABLLS —— 证书查询
    component: () => import('@/view/credentials18'),
    meta: { title: '红宝书自理课程' }
  },
  {
    name: 'credentials19', // ABLLS —— 证书查询
    component: () => import('@/view/credentials19'),
    meta: { title: '融合全攻略' }
  },
  {
    name: 'credentials20', // ABLLS —— 证书查询
    component: () => import('@/view/credentials20'),
    meta: { title: '体脑激活' }
  },
  {
    name: 'credentials21', // ABLLS —— 证书查询
    component: () => import('@/view/credentials21'),
    meta: { title: '游戏训练营' }
  },
  {
    name: 'credentials22', // ABLLS —— 证书查询
    component: () => import('@/view/credentials22'),
    meta: { title: '语言集训营' }
  },
  {
    name: 'credentials23', // ABLLS —— 证书查询
    component: () => import('@/view/credentials23'),
    meta: { title: '注意力训练营' }
  },
  {
    name: 'grade1', // 鱼计划 —— 成绩查询
    component: () => import('@/view/grade1'),
    meta: { title: '成绩查询系统' }
  },
  {
    name: 'grade2', // xxxxx —— 成绩查询
    component: () => import('@/view/grade2'),
    meta: { title: '成绩查询系统' }
  },
  {
    name: 'grade3', // 启明星工程 —— 成绩查询
    component: () => import('@/view/grade3'),
    meta: { title: '成绩查询系统' }
  },
  {
    name: 'grade4', // 精准教学 —— 成绩查询
    component: () => import('@/view/grade4'),
    meta: { title: '成绩查询系统' }
  },
  {
    name: 'grade5', // AAC辅助沟通技术 —— 成绩查询
    component: () => import('@/view/grade5'),
    meta: { title: '成绩查询系统' }
  },
  {
    name: 'result',
    component: () => import('@/view/result'),
    meta: { title: '证书查询结果展示' }
  },
  {
    name: 'resultScore',
    component: () => import('@/view/resultScore'),
    meta: { title: '成绩查询结果展示' }
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

const router = new Router({
  base: process.env.VUE_APP_PUBLIC_PATH,
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes
})

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  next()
})

export default router
